import { createFileRoute } from "@tanstack/react-router"
import { defaultMeta } from "@/lib/seo"
import { SupportChat } from "@/components/SupportChat"

export const Route = createFileRoute(`/_public/support`)({
  head: () =>
    defaultMeta({
      title: `Support`,
      description: `Chat with ChicTravel support — get help with planning, billing, or your account.`,
      path: `/support`,
    }),
  // Stays SPA: the live chat needs the session + realtime socket, so there's no
  // SSR win here and full hydration of an authed/stateful widget isn't worth it.
  ssr: false,
  component: SupportPage,
})

function SupportPage() {
  return (
    <main className="max-w-2xl mx-auto px-6 py-12 space-y-6">
      <div className="space-y-2">
        <h1 className="text-3xl font-extrabold tracking-tight">Chat with support</h1>
        <p className="text-muted-foreground leading-relaxed">
          Ask us anything about ChicTravel — planning, billing, guides, or your
          account. We&apos;ll reply right here.
        </p>
      </div>
      <SupportChat />
    </main>
  )
}
